/**
 * Merchant route lifecycle helpers.
 * - Driver acceptance: API status ASSIGNED.
 * - Dispatched/started: backend pickup flag (pickedUp=true), set when driver scans QR.
 */

const STORAGE_PREFIX = "odos_merchant_route_dispatch_v1";

function storageKey(merchantId) {
  return `${STORAGE_PREFIX}:${String(merchantId)}`;
}

export function readDispatchLog(merchantId) {
  if (merchantId == null || merchantId === "") return {};
  try {
    const raw = localStorage.getItem(storageKey(merchantId));
    if (!raw) return {};
    const o = JSON.parse(raw);
    return o && typeof o === "object" ? o : {};
  } catch {
    return {};
  }
}

export function markRouteDispatched(merchantId, routeId) {
  if (merchantId == null || routeId == null) return;
  const log = readDispatchLog(merchantId);
  log[String(routeId)] = { at: new Date().toISOString() };
  try {
    localStorage.setItem(storageKey(merchantId), JSON.stringify(log));
  } catch {
    /* ignore quota / private mode */
  }
}

export function removeRouteDispatchMark(merchantId, routeId) {
  if (merchantId == null || routeId == null) return;
  const log = readDispatchLog(merchantId);
  delete log[String(routeId)];
  try {
    localStorage.setItem(storageKey(merchantId), JSON.stringify(log));
  } catch {
    /* ignore */
  }
}

export function isRouteDispatchedByMerchant(merchantId, routeId) {
  if (merchantId == null || routeId == null) return false;
  const log = readDispatchLog(merchantId);
  return Boolean(log[String(routeId)]);
}

/**
 * @returns {'awaiting'|'accepted'|'dispatched'|'completed'|'other'}
 */
export function classifyMerchantRoute(route, merchantId) {
  const st = String(route?.status || "").toUpperCase();
  const pickedUp = route?.pickedUp === true;

  if (st === "COMPLETED") return "completed";
  if (st === "BROADCASTED") return "awaiting";
  if (st === "ASSIGNED") return pickedUp ? "dispatched" : "accepted";
  return "other";
}

/**
 * Counts for dashboard / broadcasted list (only routes relevant to broadcast flow).
 */
export function summarizeMerchantRoutePipeline(routes, merchantId) {
  let awaiting = 0;
  let acceptedPendingDispatch = 0;
  let dispatchedActive = 0;
  let completed = 0;
  let other = 0;

  for (const r of routes || []) {
    switch (classifyMerchantRoute(r, merchantId)) {
      case "awaiting":
        awaiting += 1;
        break;
      case "accepted":
        acceptedPendingDispatch += 1;
        break;
      case "dispatched":
        dispatchedActive += 1;
        break;
      case "completed":
        completed += 1;
        break;
      default:
        other += 1;
        break;
    }
  }

  return {
    awaiting,
    acceptedPendingDispatch,
    dispatchedActive,
    completed,
    other,
  };
}
